import { GenericInlineItemListTranslations } from './generic-inline-item-list-translations.interface';

export const DEFAULT_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS: GenericInlineItemListTranslations = {
  labels: {
    groupLabel: 'Item list',
    emptyList: 'No items defined.',
    itemEntry: 'Item {index} of {total}',
  },
  buttons: {
    appendItem: 'Append item',
    appendItemLabel: 'Append item',
    removeItem: 'Remove item {index}',
  },
};
